import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

const FeatureIcon = ({
  icon,
  size = '19px',
}: {
  icon: IconProp;
  size?: string | number;
}) => (
  <FontAwesomeIcon
    icon={icon}
    color="var(--primary-color)"
    style={{ fontSize: size, width: '24px', transform: 'translateY(1px)' }}
  />
);

export { FeatureIcon };
